// extracted by mini-css-extract-plugin
export default {"popupDefault":"PopupDefault_popupDefault__AkP5-","modalImageDelete":"PopupDefault_modalImageDelete__m-UBi","textPopupDefault":"PopupDefault_textPopupDefault__RcNKa"};